
import React from "react";
import styles from "./ComparePriceCard.module.scss";
import { formatCurrencyINR, formatPrice } from "@utils/numberFormatter";
import { getIndianCurrencyFormatForMaskedPrice } from "@helpers/getIndianCurrencyFormat";
import { getMaskedPricing } from "@helpers/maskPricing";
import LoginLink from "../LoginLink";

type Props = {
    adspPrice: number;
    onRoadPrice: number;
    ackoDriveSavings: number;
    cityName: string;
    isLoggedIn: boolean;
    isMobile: boolean;
};

const formatSavings = (savings: number, isLoggedIn: boolean) => {
    const formatted = isLoggedIn
        ? formatCurrencyINR(savings)
        : `₹ ${getIndianCurrencyFormatForMaskedPrice(Math.floor(savings))}`;

    return `Save up to ${formatted}`;
};

const ComparePriceCard = ({ adspPrice, onRoadPrice, ackoDriveSavings, cityName, isLoggedIn, isMobile }: Props) => {
    return (
      <div className={styles.card}>
        <div className={styles.content}>
          <div
            className={styles.label}
          >{`ACKO Drive price in ${cityName}`}</div>
          <div className={styles.bottomRow}>
            {isLoggedIn ? (
              <div className={styles.priceRow}>
                <span className={styles.currentPrice}>
                  {formatPrice(
                    adspPrice && adspPrice > 0 ? adspPrice : onRoadPrice
                  )}
                </span>
                {ackoDriveSavings && ackoDriveSavings > 0 ? (
                  <span className={styles.strikePrice}>
                    {formatPrice(onRoadPrice)}
                  </span>
                ) : null}
              </div>
            ) : (
              <div className={styles.priceRow}>
                {" "}
                <span className={styles.currentPrice}>
                  {formatPrice(onRoadPrice)}
                </span>
              </div>
            )}
            {ackoDriveSavings && ackoDriveSavings > 0 ? (
              <div className={styles.savings}>
                {formatSavings(ackoDriveSavings, isLoggedIn)}
              </div>
            ) : (
              <div className={styles.nonSellable}>This car is not on sale</div>
            )}
          </div>
        </div>
        {!isLoggedIn && adspPrice && adspPrice > 0 ? (
          <div className={styles.loginContainer}>
            {" "}
            <LoginLink isMobile={isMobile} />
          </div>
        ) : null}
      </div>
    );
};

export default ComparePriceCard;
